module.exports = __webpack_public_path__ + "static/img/qrCode4.0e3db536.png";